import { FC } from 'react';
import NoContentImage from '../../../assets/image/notItens.png';
import * as Styled from './styles';

type ModalProps = {
  className?: string;
};
const NoContent: FC<ModalProps> = (props) => (
  <Styled.Container className={props.className}>
    <Styled.Image src={NoContentImage} alt='No Content' />
    <Styled.Text>{props.children}</Styled.Text>
  </Styled.Container>
);

export default NoContent;
